// 主人公の致命の新しい版 (2026-10-12・開発版 ?lunaFinisher=new だけ・配布版は今のまま)。
//   ユーザー原文 (2026-10-12):
//     「プレイヤーの最後の致命モーションとそのエフェクトや効果音周りがまだ粗雑なので見本を作るところから始めて製品レベルに仕上げてもらいたい。」
//     どの致命か＝「両方（最後だけ特別に）」
//     普段の致命＝「N2 Bloodborne 内臓攻撃（ガスコイン神父）」＋「刺す → 押し込む → 抜く のひと続きにする（抜く時に青白い光の飛沫と火の粉を
//       抜く向きへ散らす・ボスは抜かれてから起き上がる・終わりに短く引いて立ち、床を滑る戻りをなくす・当たりの時刻と量は変えない）」
//     最後の一撃＝「白で隠さず、刺した姿を 0.3〜0.5 秒止めて見せる（Silksong ウィドウの型）。止めの間は背景だけ暗く沈める。
//       そのあと抜く拍を置いて光の柱を立て、今ある灰と霧へつなぐ。今の白い閃光の版も比較用に残す」
//     「…このゲームのラスボス撃破の演出では気持ちよさと同時に儚さというか寂しさみたいなものを表現したいと思っている。」
//       → 普段のボスの最後の一撃は Silksong ほど派手にしない。ラスボス用は今回作らないが、強められる形 (FINISHER_V2_PROFILES) にしておく。
//   二重に掛かったゆっくり (撃破まで約6秒) は未回答＝推奨「直す」で仮に進める。今の長さは ?lunaFinisherSlow=double で残す。
//   記録 = docs/research/2026-10-12-lunaire-finisher-new.md。絵 = scripts/author_lunaire_finisher_v2.mjs。音 = scripts/render_lunaire_finisher_sound.py。
//
//   このファイルは純粋な決まりだけ (描画・音は持たない)。URL を読むのは game.ts の DEV の箱の中だけ。
import { FIXED_DT } from './balance'
import type { Boss, ExecuteVariant, Player, SfxId } from './types'

export type FinisherV2Mode = 'old' | 'new'
let mode: FinisherV2Mode = 'old'
let doubleSlow = false

/** 'new' の時だけ新しい版。それ以外の値・指定なし = 今の版 (配布版)。 */
export function setFinisherV2Mode(v: string | null | undefined): void { mode = v === 'new' ? 'new' : 'old' }
export function finisherV2On(): boolean { return mode === 'new' }
/**
 * 普段の致命の版 (新しい版の中)。既定 = 'v3' (10-12c の答えで作り直した動きと光)。'v2' = 10-12 の版 (比較用・?lunaFinisherNormal=v2)。
 *   ユーザー (検収パック 10-12c): A-1「…シャワー見たいと言うかシャボン玉みたいで安っぽく見える」A-2「力がこもっている感じがしない。
 *   引き抜く時にえぐりながら引くようにしないとすっと刺してスッと引いてるように見える」A-3 抜く時の飛沫と火の粉＝「弱い」。
 */
export type ExecNormalVariant = 'v2' | 'v3'
let normalVariant: ExecNormalVariant = 'v3'
export function setExecNormalVariant(v: string | null | undefined): void { normalVariant = v === 'v2' ? 'v2' : 'v3' }
export function execNormalVariant(): ExecNormalVariant { return normalVariant }
/** 新しい版の中で、撃破までのゆっくりを今の長さ (二重掛け・約6秒) に戻す比較 = 'double'。 */
export function setFinisherV2Slow(v: string | null | undefined): void { doubleSlow = v === 'double' }
export function finisherV2DoubleSlow(): boolean { return doubleSlow }

// ============== 普段の致命 (刺す → 押し込む → 抜く) ==============
//   当たりの時刻と量は変えない (balance.ts EXECUTE: 1発 240ms・当たりは各 60〜130ms → 実際の当たりの tick は 67・300・550ms)。
//   絵 execute_v2 (0.9 s) のキー: 刺す 0.067 / 押し込む 0.30 / 抜く 0.55 / 引いて立つ 0.62〜0.90 (終わりの姿 = 立ち姿)。
export const EXEC_V2 = {
  anim: 'execute_v2',
  /** 当たりの時刻 (s・絵のキー)。抜いた瞬間 = 3発目。 */
  stabSec: 0.067,
  pushSec: 0.3,
  pullSec: 0.55,
  /** ボスが崩れ姿のまま留まる長さ (主人公の致命の経過 ms)。抜いた (550) 後もう一拍置いてから起き上がる。 */
  bossRiseAtMs: 700,
  /** 起き上がりの混ぜ (s)。sprites.ts の TRANSITION_DURATION_SEC と同じ 150ms。 */
  bossRiseMixSec: 0.15,
  /** 刺し傷の高さ (主人公の足元から上へ px)。刺した姿の刃の高さ (execute_v2 を骨で測った値)。 */
  woundAbovePlayerPx: 66,
  /** 刺し傷の横の位置 = ボスの体の縁から内側へ (体の半幅に掛ける割合)。 */
  woundIntoBody: 0.35,
  /** FX の寿命 (s)。抜いた時の飛沫が落ちきるまで。game.ts の ageFx が使う。 */
  fxLifeSec: 1.0,
} as const

// ============== 普段の致命 3 版目 (execute_v3・刺す → 体重を預けて押し込む → こじる → 引っかかる → 一気に抜ける) ==============
//   絵 = scripts/author_lunaire_finisher_v3.mjs。当たりの時刻は v2 と同じ (stabSec / pushSec / pullSec)・量・止め・揺れも同じ。
//   光 = src/luna_exec_fx_v3.ts (v2 の粒は使わない)。
export const EXEC_V3 = {
  anim: 'execute_v3',
  /**
   * 刃が傷へ入っている所 (主人公の足元から・前へ / 上へ px)。絵の剣の骨の先 = 傷の入り口として動きを作った (こじる時はここを支点に手元が上下する)。
   *   1 = 刺した所 / 2 = 押し込んだ所 / 3 = 抜けた所 (抜ける直前の支点)。値は author_lunaire_finisher_v3.mjs の狙いの点と同じ。
   */
  woundPx: { 1: { fwd: 96, up: 65 }, 2: { fwd: 106, up: 62 }, 3: { fwd: 100, up: 63 } },
  fxLifeSec: 1.6,
} as const

/**
 * 普段の致命の光の見た目 (3 版目の動きの中)。既定 = 'c' 火花の爆ぜ (src/luna_exec_fx_c.ts)。'a' = 光の血煙 (src/luna_exec_fx_v3.ts・比較用 &lunaExecFx=a)。
 *   ユーザー (検収パック 10-12d A-2): 「Aは氷とか吹雪っぽいな。Cが良さそう」。記録 = docs/research/2026-10-12-lunaire-finisher-fx-c.md。
 */
export type ExecFxLook = 'a' | 'c'
let execFxLook: ExecFxLook = 'c'
export function setExecFxLook(v: string | null | undefined): void { execFxLook = v === 'a' ? 'a' : 'c' }
export function execFxLookNow(): ExecFxLook { return execFxLook }
/** C の光の寿命 (s)。src/luna_exec_fx_c.ts EXEC_C_FX_LIFE_SEC と同じ値 (描画のファイルを決まりから読まないため写す・テストで一致を縛る)。 */
export const EXEC_C_FX_LIFE = 1.5

/** 普段の致命の光の寿命 (s)。版で変わる (game.ts の ageFx)。 */
export function execFxLifeSec(): number {
  if (normalVariant !== 'v3') return EXEC_V2.fxLifeSec
  return execFxLook === 'c' ? EXEC_C_FX_LIFE : EXEC_V3.fxLifeSec
}

/**
 * 普段の致命の各発の傷の位置 (世界座標)。v3 = 主人公の剣が実際に入っている所 (絵の剣の先)。v2 = 今まで通り (ボスの体の縁から内側)。
 *   v3 を主人公から測るのは、光が剣の先から出るように (ボスの体の幅で決めると、間合いで剣先と光がずれる)。
 */
export function execNormalWoundPoint(player: Pick<Player, 'x' | 'y' | 'facing'>, boss: Pick<Boss, 'x' | 'bodyHalfWidthPx'>, hit: 1 | 2 | 3): { x: number, y: number, dir: 1 | -1 } {
  if (normalVariant === 'v2') return execWoundPoint(player, boss)
  const dir: 1 | -1 = player.facing === 'left' ? -1 : 1
  const w = EXEC_V3.woundPx[hit]
  return { x: player.x + dir * w.fwd, y: player.y - w.up, dir }
}

/** 刺し傷の位置 (世界座標)。dir = 主人公の向き (+1 = 右)。 */
export function execWoundPoint(player: Pick<Player, 'x' | 'y' | 'facing'>, boss: Pick<Boss, 'x' | 'bodyHalfWidthPx'>): { x: number, y: number, dir: 1 | -1 } {
  const dir: 1 | -1 = player.facing === 'left' ? -1 : 1
  const edge = boss.x - dir * boss.bodyHalfWidthPx
  const x = edge + dir * boss.bodyHalfWidthPx * EXEC_V2.woundIntoBody
  // 主人公の側を越えない (近すぎる時は主人公の剣の届く所まで)
  const minFromPlayer = 40
  const clamped = dir > 0 ? Math.max(player.x + minFromPlayer, x) : Math.min(player.x - minFromPlayer, x)
  return { x: clamped, y: player.y - EXEC_V2.woundAbovePlayerPx, dir }
}

/** 普段の致命の各発の音 (新しい版)。振りの音 (attack_swing) は重ねない = 体と得物の音だけ。 */
export function execV2Sfx(hitIndex: number): SfxId[] {
  return [hitIndex === 0 ? 'execute_hit1' : hitIndex === 1 ? 'execute_hit2' : 'execute_hit3']
}

/**
 * ボスを崩れ姿のまま見せるか (描画だけ・ゲームの状態は変えない)。
 *   3発目の当たりでボスの状態は待機へ戻る (combat.ts・攻撃の間合いの時計もそこから)。新しい版は、絵だけ抜いた後の bossRiseAtMs まで崩れ姿を保ち、
 *   そこから bossRiseMixSec で立ち姿へ混ぜる。戻り値 hold = 崩れ姿のまま／rise = 立ち姿へ混ぜている残り (s)／null = 何もしない。
 */
export function execBossStaggerHold(player: Pick<Player, 'state' | 'executeVariant' | 'stateElapsed'>, bossHp: number):
  { hold: true } | { hold: false, riseRemainSec: number } | null {
  if (!finisherV2On() || bossHp <= 0) return null
  if (player.state !== 'executing' || player.executeVariant !== 'normal') return null
  const ms = player.stateElapsed * 1000
  if (ms < EXEC_V2.pullSec * 1000 - 1) return null       // 3発目より前はボスはまだ崩れ中 (本物の状態のまま)
  if (ms < EXEC_V2.bossRiseAtMs) return { hold: true }
  const remain = EXEC_V2.bossRiseMixSec - (ms - EXEC_V2.bossRiseAtMs) / 1000
  return remain > 0 ? { hold: false, riseRemainSec: remain } : null
}

/** 致命の絵の名前 (新しい版)。普段 = execute_v3 (比較 ?lunaFinisherNormal=v2 = execute_v2)・最後 = execute_finisher_v2。 */
export function execV2AnimName(variant: ExecuteVariant): string {
  return variant === 'finisher' ? FINISHER_V2_ANIM.windup : normalVariant === 'v2' ? EXEC_V2.anim : EXEC_V3.anim
}

// ============== 最後の一撃 (刺した姿を止めて見せる → 抜く → 光の柱 → 灰と霧) ==============
export const FINISHER_V2_ANIM = {
  /** 溜め → 刺す (当たり 0.55 s)。 */
  windup: 'execute_finisher_v2',
  /** 止めの後: 抜く (0.05 s) → 血振り → 立って剣を下ろす (0.9 s・最後の姿で止まる)。 */
  pull: 'execute_finisher_v2_pull',
} as const

export interface FinisherProfile {
  /** 刺した姿で止める長さ (ms・ヒットストップ)。ユーザー「0.3〜0.5 秒」。 */
  freezeMs: number
  /** 止めの間の背景の暗さ (0〜1・黒を重ねる濃さ)。 */
  darkAlpha: number
  /** 暗さが満ちるまで (止めの経過 ms)。 */
  darkInMs: number
  /** 止めが明けてから暗さが引くまで (finisher の経過 ms)。 */
  darkOutMs: number
  /** 止めが明けてから剣が抜ける瞬間 (finisher の経過 ms・音と飛沫と光の柱の出る時刻)。絵 execute_finisher_v2_pull のキーと揃える。 */
  pullAtMs: number
  /** 光の柱が立ち上がりきるまで / 保つ / 消えるまで (finisher の経過 ms・抜いた瞬間から)。 */
  pillarRiseMs: number
  pillarHoldMs: number
  pillarFadeMs: number
  /** 光の柱の幅 (px・芯の半幅) と明るさ (0〜1)。 */
  pillarHalfWidth: number
  pillarAlpha: number
  /** 抜いた時の飛沫の数 (青白い光の粒 / 火の粉)。 */
  sprayBlue: number
  sprayEmber: number
  /** 刺した瞬間の揺れ (止めの頭で振れて、止めの間に静まる)。 */
  shake: { amplitude: number, durationMs: number }
}

/**
 * 強さの段 (後でラスボス用に強められる作り)。今は全部のボスが 'boss'。
 *   'lastBoss' は今回作らない (ユーザー: ラスボスは気持ちよさと同時に儚さ・寂しさ)。値は叩き台で、使う時に作り直す前提。
 */
export const FINISHER_V2_PROFILES: Record<'boss' | 'lastBoss', FinisherProfile> = {
  boss: {
    freezeMs: 420,
    darkAlpha: 0.64,
    darkInMs: 70,
    darkOutMs: 320,
    pullAtMs: 50,
    pillarRiseMs: 220,
    pillarHoldMs: 260,
    pillarFadeMs: 700,
    pillarHalfWidth: 15,
    pillarAlpha: 0.62,
    sprayBlue: 26,
    sprayEmber: 18,
    shake: { amplitude: 9, durationMs: 220 },
  },
  lastBoss: {
    freezeMs: 650,
    darkAlpha: 0.78,
    darkInMs: 110,
    darkOutMs: 520,
    pullAtMs: 50,
    pillarRiseMs: 320,
    pillarHoldMs: 520,
    pillarFadeMs: 1100,
    pillarHalfWidth: 24,
    pillarAlpha: 0.8,
    sprayBlue: 40,
    sprayEmber: 30,
    shake: { amplitude: 12, durationMs: 300 },
  },
}

/** そのボスの強さの段。今は全部 'boss' (ラスボスを作る時にここで分ける)。 */
export function finisherProfileFor(_bossId: string): FinisherProfile {
  return FINISHER_V2_PROFILES.boss
}

/**
 * 1 tick で進める撃破の時計 (ms)。今の版は tick の数 (main.ts の accumulator) と時計の両方にゆっくりが掛かる = 二重 (約6秒)。
 *   新しい版は時計にだけは掛けない = ゆっくりは tick の数の1回だけ (拍の設計どおりの実時間)。?lunaFinisherSlow=double で今の長さ。
 */
export function finisherClockStepMs(timeScale: number): number {
  if (finisherV2On() && !doubleSlow) return FIXED_DT * 1000
  return FIXED_DT * 1000 * timeScale
}

// ============== 最後の一撃 C (2026-10-12・検収パック 10-12d の答え・既定) ==============
//   ユーザー (B-1)「新しいやつのほうが良いけど、前のやつが残ってるのも変だし、色んなところから色々出てきててよくわからないことになってる」
//   (B-3) 撃破の画面まで＝今の長さ (約6秒)／(B-4) 抜いた時の光の柱と飛沫＝弱い／(B-2) 止め 0.42 秒＝ちょうどいい。
//   → 出どころを刺し傷 1 か所にまとめる (魔法陣・ボスの中心の灰・画面いっぱいの霧と光・古い飛沫は出さない)。光は普段の致命の C と同じ血筋で大きく。
//   → 長さは「当たり → 撃破の画面」約 6.0 秒。延びた分は、抜いた後のゆっくり (0.4 倍・0.4 秒ぶん) と、名前の前の静けさと、名前の長さで埋める。
//   時計: state.finisher.elapsedMs は今まで通り finisher.ts の拍の時計 (ボスが崩れる・名前・撃破の終わりが読む)。
//     C では「止めが明けてからのゲームの ms (gm)」を決め、拍の時計はその折れ線で決める (finisherCClockOfGm)。描画は gm で描く。
//   ?lunaFinFx=v2 = 前の版 (飛沫 v2・控えめな柱・魔法陣と灰と霧・4.17 秒。&lunaFinisherSlow=double で約6秒の二重掛け)。
export type FinisherFxLook = 'c' | 'v2'
let finFxLook: FinisherFxLook = 'c'
export function setFinisherFxLook(v: string | null | undefined): void { finFxLook = v === 'v2' ? 'v2' : 'c' }
/** 最後の一撃が C (新しい版の中の既定) か。 */
export function finisherCOn(): boolean { return finisherV2On() && finFxLook === 'c' }

export const FIN_C = {
  /** 止めの後、剣が抜ける gm (音 finisher_pull・爆ぜ・柱)。拍の時計でも 50 (gm 0〜150 は拍の時計と同じ)。 */
  pullAtGm: 50,
  /** 抜いた後のゆっくり: 倍率・gm この間はそのまま・そこから 1 へ戻すまで。 */
  slowScale: 0.4, slowFromGm: 50, slowHoldToGm: 450, slowEaseToGm: 800,
  /** ボスが崩れる (拍 pull = 150〜570 + 本体の遅れ 40) を gm 190〜950 に当てる。 */
  dissolveEndGm: 950,
  /** 名前が出る gm (拍 silence の頭 = T_SILENCE・音 finisher_name)。 */
  nameAtGm: 2300,
  /** 当たりから撃破の画面までの狙い (実時間 ms・止めを含む)。 */
  totalRealMs: 6000,
  /** 背景の暗さ: 抜いた後に残す濃さ・そこまで引く gm・名前の間に引いていく先。 */
  darkHold: 0.4, darkHoldInGm: 500, darkEnd: 0,
} as const

/** C のゆっくり (gm の関数・game.ts の state.timeScale = tick の数に掛かる)。 */
export function finisherCTimeScale(gm: number): number {
  const c = FIN_C
  if (gm < c.slowFromGm) return 1
  if (gm < c.slowHoldToGm) return c.slowScale
  if (gm < c.slowEaseToGm) {
    const u = (gm - c.slowHoldToGm) / (c.slowEaseToGm - c.slowHoldToGm)
    return c.slowScale + (1 - c.slowScale) * u * u * (3 - 2 * u)
  }
  return 1
}
/** gm までの実時間 (ms)。tick ごとに 1/60 秒のゲームの時間が timeScale で引き延ばされる (main.ts の accumulator)。 */
export function finisherCRealMsOfGm(gm: number): number {
  const step = FIXED_DT * 1000
  let real = 0
  for (let g = 0; g < gm; g += step) real += Math.min(step, gm - g) / finisherCTimeScale(g)
  return real
}
/** 撃破の終わり (拍の時計 T_END) の gm。当たり → 撃破の画面 = totalRealMs になるように決める (止め freezeMs を引いた残り)。 */
export const FIN_C_END_GM = (() => {
  const target = FIN_C.totalRealMs - FINISHER_V2_PROFILES.boss.freezeMs
  const realAtName = finisherCRealMsOfGm(FIN_C.nameAtGm)
  return FIN_C.nameAtGm + Math.max(0, target - realAtName)   // 名前の後は timeScale 1 = ゲームの ms と実時間が同じ
})()
// 拍の時計 (finisher.ts) の要所: T_PULL 150・本体の崩れの終わり 570+40・T_SILENCE 1230・T_END 2830。
//   finisher.ts を読まずに済むよう数で持つ (テストで finisher.ts の値と一致を縛る)。
const BEAT = { pull: 150, bodyEnd: 610, silence: 1230, end: 2830 } as const
const C_KNOTS: [number, number][] = [[0, 0], [BEAT.pull, BEAT.pull], [FIN_C.dissolveEndGm, BEAT.bodyEnd], [FIN_C.nameAtGm, BEAT.silence], [FIN_C_END_GM, BEAT.end]]
function lerpKnots(v: number, from: 0 | 1): number {
  const to = (1 - from) as 0 | 1
  if (v <= 0) return 0
  for (let i = 1; i < C_KNOTS.length; i++) {
    const a = C_KNOTS[i - 1], b = C_KNOTS[i]
    if (v <= b[from]) return a[to] + ((v - a[from]) / (b[from] - a[from])) * (b[to] - a[to])
  }
  const last = C_KNOTS[C_KNOTS.length - 1]
  return last[to] + (v - last[from])
}
export function finisherCClockOfGm(gm: number): number { return lerpKnots(gm, 0) }
export function finisherCGmOfClock(clockMs: number): number { return lerpKnots(clockMs, 1) }
export const FIN_C_BEATS = BEAT

/**
 * 撃破の時計を 1 tick 進めた値 (game.ts)。C = gm を 1 tick 進めて拍の時計へ写す／それ以外 = 今まで通り (finisherClockStepMs)。
 */
export function finisherClockNext(clockMs: number, timeScale: number): number {
  if (!finisherCOn()) return clockMs + finisherClockStepMs(timeScale)
  return finisherCClockOfGm(finisherCGmOfClock(clockMs) + FIXED_DT * 1000)
}
/** 撃破の間の state.timeScale (game.ts)。C = finisherCTimeScale／それ以外 = null (finisher.ts の finisherTimeScale を使う)。 */
export function finisherCTimeScaleOfClock(clockMs: number): number | null {
  return finisherCOn() ? finisherCTimeScale(finisherCGmOfClock(clockMs)) : null
}

/** C の背景の暗さ (0〜)。止めの間に満ちる (今と同じ) → 抜いた後 darkHold まで引いて静けさの間は残す → 名前の後半で 0 へ。 */
export function finisherCBgDark(clockMs: number, hitStopRemainingSec: number): number {
  const p = FINISHER_V2_PROFILES.boss
  const fp = finisherFreezeProgress(clockMs, hitStopRemainingSec, p)
  if (fp !== null) return finisherBgDark(clockMs, hitStopRemainingSec, p)
  const gm = finisherCGmOfClock(clockMs)
  if (gm <= 0) return p.darkAlpha
  const c = FIN_C
  if (gm < c.darkHoldInGm) {
    const u = gm / c.darkHoldInGm
    return p.darkAlpha + (c.darkHold - p.darkAlpha) * u * u * (3 - 2 * u)
  }
  const fadeFrom = c.nameAtGm + (FIN_C_END_GM - c.nameAtGm) * 0.4
  if (gm < fadeFrom) return c.darkHold
  const u = Math.min(1, (gm - fadeFrom) / (FIN_C_END_GM - fadeFrom))
  return c.darkHold + (c.darkEnd - c.darkHold) * u
}

/** 最後の一撃 C の刺し傷 (世界座標) = 主人公の剣の先 (execute_finisher_v2 の当たり 0.55 の剣の骨の先・前へ 105 / 上へ 62)。 */
export const FIN_C_WOUND_PX = { fwd: 105, up: 62 } as const
export function finisherCWoundPoint(player: Pick<Player, 'x' | 'y' | 'facing'>): { x: number, y: number, dir: 1 | -1 } {
  const dir: 1 | -1 = player.facing === 'left' ? -1 : 1
  return { x: player.x + dir * FIN_C_WOUND_PX.fwd, y: player.y - FIN_C_WOUND_PX.up, dir }
}

/** 撃破の時計が prev → next へ進んだ時に鳴らす音 (新しい版)。抜く瞬間と、名前が出る瞬間に静かな1音。 */
export function finisherV2BeatSfx(prevMs: number, nextMs: number, profile: FinisherProfile, silenceAtMs: number): SfxId[] {
  const out: SfxId[] = []
  if (prevMs < profile.pullAtMs && nextMs >= profile.pullAtMs) out.push('finisher_pull')
  if (prevMs < silenceAtMs && nextMs >= silenceAtMs) out.push('finisher_name')
  return out
}

/** 止めの進み具合 (0 → 1)。hitStopRemaining (s) から。止めの外は null。 */
export function finisherFreezeProgress(elapsedMs: number, hitStopRemainingSec: number, profile: FinisherProfile): number | null {
  if (elapsedMs > 0 || hitStopRemainingSec <= 0) return null
  return Math.max(0, Math.min(1, 1 - hitStopRemainingSec * 1000 / profile.freezeMs))
}

/** 背景を沈める暗さ (0〜profile.darkAlpha)。止めの頭で満ち、抜いた後に引く。 */
export function finisherBgDark(elapsedMs: number, hitStopRemainingSec: number, profile: FinisherProfile): number {
  const fp = finisherFreezeProgress(elapsedMs, hitStopRemainingSec, profile)
  if (fp !== null) {
    const ms = fp * profile.freezeMs
    const k = Math.min(1, ms / profile.darkInMs)
    return profile.darkAlpha * (1 - (1 - k) * (1 - k))
  }
  if (elapsedMs <= 0) return 0
  const out = Math.min(1, elapsedMs / profile.darkOutMs)
  return profile.darkAlpha * (1 - out) * (1 - out)
}

/** 光の柱の強さ (0〜1) と高さの割合 (0〜1)。抜いた瞬間から立ち上がる。 */
export function finisherPillar(elapsedMs: number, profile: FinisherProfile): { level: number, rise: number } {
  const t = elapsedMs - profile.pullAtMs
  if (t < 0) return { level: 0, rise: 0 }
  const rise = Math.min(1, t / profile.pillarRiseMs)
  const riseE = 1 - (1 - rise) ** 3
  const afterHold = t - profile.pillarRiseMs - profile.pillarHoldMs
  const fade = afterHold <= 0 ? 1 : Math.max(0, 1 - afterHold / profile.pillarFadeMs)
  const level = Math.min(1, t / 60) * fade * fade
  return { level, rise: riseE }
}

/** 光の柱が描き終わる finisher の経過 (ms)。撃破の時計 (finisher.ts の T_END) より短いこと (型②・テストで縛る)。 */
export function finisherPillarEndMs(profile: FinisherProfile): number {
  return profile.pullAtMs + profile.pillarRiseMs + profile.pillarHoldMs + profile.pillarFadeMs
}

// ============== 音 (書き出し = scripts/render_lunaire_finisher_sound.py・鳴らす = src/audio.ts) ==============
//   fileM400 = 書き出した WAV の 400ms の最大ラウドネス (scripts/sfx_measure.py)。gainDb = ゲームで掛ける音量。
//   ゲームの出力 ≒ fileM400 + gainDb + 3.3 (弾きの柳の型の WAV -14.0・gainDb -8.0 → 出力 -18.7 から見積もった差)。
//   決まり: どれも弾き (出力 -19.6〜-18.4) より小さい・普段は 刺す < 押し込む ≦ 抜く ではなく 抜くが一番大きい・最後の一撃の刺すが致命で一番大きい。
//   2版目 (2026-10-12 夜・scripts/render_lunaire_finisher_sfx_v2.py・記録 docs/research/2026-10-12-lunaire-finisher-sfx-v2.md):
//     ユーザー (10-12c A-4)「普段の致命の音は完全オリジナルだよね？どうすれば僕が求めてる感じになるかな／最後の一撃の音はこれはこれでいいけどもっと磨けるはず」
//     → 普段の3本を録音のような素材 (ElevenLabs) の層で作り直した組 a / b / c。最後の一撃は今の方向のまま素材の層を足した v2。
//     (2版目の時の) 既定 = 普段 'a' (湿り・推し)・最後 'v2'。比較 = 開発版 &lunaExecSfx=b|c|synth (synth = 1版目の数式の音)・&lunaFinSfx=v1 (1版目)。
//     押し込む音は次の当たり (0.367 秒後) の直前で切れる長さ = 終わりへ向けて「えぐる」擦れが膨らみ、抜く音の解放へ渡す。
//   3版目 (2026-10-12・scripts/render_lunaire_finisher_sfx_v3.py・記録 docs/research/2026-10-12-lunaire-finisher-sfx-v3.md):
//     ユーザー (10-12d A-5)「軽くてプラスティックとか氷みたいな音になってる」・B-5 最後の一撃も「音の質が合わない」
//     → 2版目は肉の素材の芯が 4〜7kHz・200〜1200Hz が抜け・尾に 2〜6kHz の鳴りが残っていた。素材を取り直し、低く・厚く・暗い響きで作り直した。
//     組 d = 肉の厚み (推し・既定)・e = 骨に引っかかる・f = 体の奥。最後の一撃も同じ方向で v3d / v3e / v3f (名前の鐘は 3 つとも luna_fin_name_v3)。
//     既定 = 普段 'd'・最後 'v3d'。2版目以前は &lunaExecSfx=a|b|c|synth・&lunaFinSfx=v2|v1 で残る。
//     outM400 = 聞き比べ動画で測ったゲームの出力の見積もり (当たりの 30ms 前から 330ms・前の版と同じ測り方)。低い帯の多い 3版目は
//     「fileM400 + gainDb + 3.3」の見積もりが 3〜4dB 外れたので、測った値を持たせる (lunaSfxOutputM400 がこちらを優先)。
//   4版目 (2026-10-13・scripts/render_lunaire_finisher_sfx_v4.py・記録 docs/research/2026-10-13-lunaire-finisher-sfx-v4.md):
//     ユーザー (3版目への答え)「ちょっとグチュグチュしすぎだな。あと、もっと脳汁が出るような音であるべき (ボスの致命をパリィした音とかはめちゃくちゃ気持ちいい。)」
//     ／最後の一撃「鐘は要らない」→ 手本 = ボスの致命を弾いた音 (parry_exec_push「ガキン→ゴン」の二段＋音程のある鳴り)。
//     弾きと同じ材料 (本番の鋼・沈む「ドン」・刃の鳴り・擦れ・火花) を主役にし、肉は出だし 70ms の1粒だけ脇に置いた。
//     組 g = 弾きの二段 (推し・既定)・h = 柳の軽さ・i = 重い打撃と爆ぜ。最後の一撃も同じ方向で v4g / v4h / v4i。
//     名前の鐘は既定で鳴らさない (どの組でも)。前の鐘は開発版 &lunaFinBell=on で鳴る (組に鐘が無い 4版目は luna_fin_name_v3)。
//     既定 = 普段 'g'・最後 'v4g'。3版目以前は &lunaExecSfx=d|e|f|a|b|c|synth・&lunaFinSfx=v3d|v3e|v3f|v2|v1 で残る。
//   5版目「解放」(2026-10-14・scripts/render_lunaire_finisher_sfx_v5.py・記録 docs/research/2026-10-14-parry-sfx-old-vs-new.md §5):
//     手本を聞いた答え = 近い「BB 内臓攻撃」・少し近い「ER 致命」→ 共通点 = 抜く前の膨らみ・暗く低い長い尾・弱い音程のにじみ (案 A 吸って、吐く)。
//     組 j = 内臓攻撃寄り・k = 致命寄り (低い唸りの溜め)・l = j＋抜く瞬間だけ低い鋼。開発版 &lunaExecSfx=j|k|l だけ (既定は g のまま)。
//     大きさは g と同じ (fileM400 と gainDb をそろえた・出力は見積もり)。
//   6版目 (2026-10-15・scripts/render_lunaire_finisher_sfx_v6.py・記録 docs/research/2026-10-15-parry-material-and-exec-sfx.md):
//     ユーザー (5版目への答え)「どれも演奏っぽさあるし、新しく作ってくれたのは砂嵐みたいで意味わからない」・抜いた後の低い音「長くてくどい」
//     → 膨らむ雑音 (溜め) と低い正弦のにじみの尾をやめ、抜いた後は -20dB まで 0.6 秒以内。
//     組 m = 静かに抜く (合成だけ・AI で作った素材なし)・n = 弾きの血筋 (冷たい銀の鋼を短く)・o = 体の音だけ (AI の素材の出だしだけ)。
//     開発版 &lunaExecSfx=m|n|o だけ (既定は g のまま)。大きさは g と同じ。
//   7版目 (2026-10-21・scripts/render_lunaire_finisher_sfx_v7.py・記録 docs/research/2026-10-21-exec-release-sfx-rebuild.md):
//     ユーザー (6版目への答え)「全部楽器みたいで変。」・演奏っぽさと砂嵐はまだある
//     → 測った原因 = 沈む正弦の低い「ドン」(40〜63Hz・周りより 17〜28dB 突き出る)・調律した刃の鳴り (g の 660Hz・495/990Hz)・3打で音の高さが下がる並び。
//     音の高さを持つ材料をやめ、高さの出ない材料 (一度だけ押す圧・ばらばらの周波数で短く減る体の鳴り・不規則な粒・短い雑音) だけで作り直した。6kHz より上は削った。
//     組 p = 粒の手応え・q = 体の圧・r = 芯の一打。開発版 &lunaExecSfx=p|q|r だけ (既定は g のまま)。大きさは g と同じ (fileM400 と gainDb をそろえた)。
export interface LunaSfxSpec { sample: string, url: string, gainDb: number, reverb: number, fileM400: number, outM400?: number }
type ExecBeat = 'execute_hit1' | 'execute_hit2' | 'execute_hit3'
/** 最後の一撃の組。finisher_name (名前の鐘) は 3版目以前の組だけが持つ (4版目は鐘なし)。 */
type FinSet = { execute: LunaSfxSpec, finisher_pull: LunaSfxSpec, finisher_name?: LunaSfxSpec }
export type LunaExecSfxSet = 'p' | 'q' | 'r' | 'm' | 'n' | 'o' | 'j' | 'k' | 'l' | 'g' | 'h' | 'i' | 'd' | 'e' | 'f' | 'a' | 'b' | 'c' | 'synth'
export type LunaFinSfxSet = 'v4g' | 'v4h' | 'v4i' | 'v3d' | 'v3e' | 'v3f' | 'v2' | 'v1'
const spec = (file: string, v: number, gainDb: number, reverb: number, fileM400: number, outM400?: number): LunaSfxSpec =>
  ({ sample: file, url: `/sfx/${file}.wav?v=${v}`, gainDb, reverb, fileM400, ...(outM400 === undefined ? {} : { outM400 }) })
export const LUNA_EXEC_SFX_SETS: Record<LunaExecSfxSet, Record<ExecBeat, LunaSfxSpec>> = {
  // p = 粒の手応え (7版目・高さの出る材料なし): 刺す = 層を破る不規則な粒＋圧／押し込む = 骨を擦る細かい粒＋体重の圧／抜く = 割れが崩れる粒＋一番広い圧
  p: {
    execute_hit1: spec('luna_exec_stab_p', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_p', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_p', 1, -5.9, 0.03, -18.1),
  },
  // q = 体の圧 (7版目): 圧と柔らかい体の鳴りだけ・2kHz より上はほとんど無し／抜く = 吸い出す逆向きの圧
  q: {
    execute_hit1: spec('luna_exec_stab_q', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_q', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_q', 1, -5.9, 0.03, -18.1),
  },
  // r = 芯の一打 (7版目): 1打ごとに硬い体の当たり1つ＋圧・粒も尾もほぼ無し
  r: {
    execute_hit1: spec('luna_exec_stab_r', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_r', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_r', 1, -5.9, 0.03, -18.1),
  },
  // m = 静かに抜く (6版目・合成だけ): 刺す = 短い「ズッ」／押し込む = 体重の「グッ」だけ／抜く = 体の圧の「ドッ」・すぐ消える
  m: {
    execute_hit1: spec('luna_exec_stab_m', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_m', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_m', 1, -5.9, 0.03, -18.1),
  },
  // n = 弾きの血筋 (6版目): 刺す・押し込むに低く短い鋼の当たり／抜く = 冷たい銀の鋼を低く短く「ガキン」＋「ドッ」
  n: {
    execute_hit1: spec('luna_exec_stab_n', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_n', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_n', 1, -5.9, 0.03, -18.1),
  },
  // o = 体の音だけ (6版目): AI で作った肉の素材の出だし 70ms だけ＋小さな「ドッ」・鋼も尾も無し
  o: {
    execute_hit1: spec('luna_exec_stab_o', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_o', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_o', 1, -5.9, 0.03, -18.1),
  },
  // j = 内臓攻撃寄り (5版目・解放): 刺す = 短く低い「ズッ」／押し込む = 乾いた擦れが抜く直前へ膨らむ／抜く = 低い「ドォン」と暗い尾 2.4 秒
  j: {
    execute_hit1: spec('luna_exec_stab_j', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_j', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_j', 1, -5.9, 0.03, -18.1),
  },
  // k = 致命寄り (5版目): 押し込むの溜めは体の中の低い唸り (最後の 0.2 秒で上がる)／抜く = 重い「ドッ」とずっと暗い尾 2.2 秒
  k: {
    execute_hit1: spec('luna_exec_stab_k', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_k', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_k', 1, -5.9, 0.03, -18.1),
  },
  // l = j＋刃の気配 (5版目): j の形に、抜く瞬間だけ低く鳴らした鋼 (弾きの冷たい銀と同じ素材) を短く重ねる・尾 2.0 秒
  l: {
    execute_hit1: spec('luna_exec_stab_l', 1, -10.1, 0.02, -17.2),
    execute_hit2: spec('luna_exec_push_l', 1, -11.5, 0.02, -17.0),
    execute_hit3: spec('luna_exec_pull_l', 1, -5.9, 0.03, -18.1),
  },
  // g = 弾きの二段 (4版目・推し): 刺す = 鋼の「キッ」→ 45ms 後に体の「ド」＋短い刃の鳴り (E5)／押し込む = 鈍い鋼の「ゴッ」と体重、骨を擦る音が抜く前へ膨らむ／
  //     抜く = 手本と同じ「ガキン→ゴン」(70ms) の二段＋刃の鳴り (B4) が残る＋金の火花。肉は出だしの1粒だけ
  g: {
    execute_hit1: spec('luna_exec_stab_g', 1, -10.1, 0.04, -17.2, -24.1),
    execute_hit2: spec('luna_exec_push_g', 1, -11.5, 0.03, -17.0, -25.3),
    execute_hit3: spec('luna_exec_pull_g', 1, -5.9, 0.05, -18.1, -20.9),
  },
  // h = 柳の軽さ (4版目): 普段の弾き (柳の型) の血筋。細く鋭い「キンッ」・軽い当たり・高めの刃の鳴り (短い)・火花
  h: {
    execute_hit1: spec('luna_exec_stab_h', 1, -10.2, 0.04, -17.1, -24.0),
    execute_hit2: spec('luna_exec_push_h', 1, -11.5, 0.03, -17.0, -25.3),
    execute_hit3: spec('luna_exec_pull_h', 1, -7.0, 0.05, -17.2, -21.0),
  },
  // i = 重い打撃と爆ぜ (4版目): 低い「ドン」と鈍い鋼が主役・鳴りは短く、燠が爆ぜる粒の尾 (光 C の火花)
  i: {
    execute_hit1: spec('luna_exec_stab_i', 1, -10.1, 0.04, -17.1, -24.0),
    execute_hit2: spec('luna_exec_push_i', 1, -11.5, 0.03, -17.0, -25.4),
    execute_hit3: spec('luna_exec_pull_i', 1, -6.8, 0.05, -17.2, -20.9),
  },
  // d = 肉の厚み (3版目・推し): 厚い肉に刃が入る「ドスッ」・押し込みは体重の「グッ」とこじる湿り 2 回・抜くは低い「ズボッ」と重い血と小さな火花の爆ぜ
  d: {
    execute_hit1: spec('luna_exec_stab_d', 1, -6.1, 0.03, -16.9, -24.0),
    execute_hit2: spec('luna_exec_push_d', 1, -11.3, 0.03, -14.0, -25.3),
    execute_hit3: spec('luna_exec_pull_d', 1, -6.9, 0.05, -14.0, -20.8),
  },
  // e = 骨に引っかかる (3版目): 刃が骨に当たる鈍い「ゴッ」・こじる間に筋が軋み、引っかかる所で骨が鳴る・抜くは骨から外れる「ゴキッ」
  e: {
    execute_hit1: spec('luna_exec_stab_e', 1, -5.8, 0.03, -16.8, -24.0),
    execute_hit2: spec('luna_exec_push_e', 1, -11.4, 0.03, -14.0, -25.3),
    execute_hit3: spec('luna_exec_pull_e', 1, -6.9, 0.05, -14.1, -20.8),
  },
  // f = 体の奥 (3版目): 体の中で鳴るこもった低い受けが主役・一番暗い (小さいスピーカーでは一番痩せる)
  f: {
    execute_hit1: spec('luna_exec_stab_f', 1, -10.1, 0.03, -14.0, -24.0),
    execute_hit2: spec('luna_exec_push_f', 1, -11.1, 0.03, -14.0, -25.3),
    execute_hit3: spec('luna_exec_pull_f', 1, -6.9, 0.05, -14.0, -20.8),
  },
  // a = 湿り (Bloodborne の内臓攻撃寄り): 肉の湿った音が主役＋低い体の受け・刃の金属は抜く時に小さく一閃
  a: {
    execute_hit1: spec('luna_exec_stab_a', 1, -9.8, 0.05, -17.5),
    execute_hit2: spec('luna_exec_push_a', 1, -10.8, 0.04, -17.0),
    execute_hit3: spec('luna_exec_pull_a', 1, -7.2, 0.08, -17.1),
  },
  // b = 鋭さ (Sekiro の忍殺寄り): 刃が主役・短く締まる・抜く時に銀が鳴る
  b: {
    execute_hit1: spec('luna_exec_stab_b', 1, -9.0, 0.05, -18.3),
    execute_hit2: spec('luna_exec_push_b', 1, -10.8, 0.04, -17.0),
    execute_hit3: spec('luna_exec_pull_b', 1, -7.2, 0.08, -17.1),
  },
  // c = 骨と重み (Lies of P 寄り): 低い体の受けと骨の軋みが主役
  c: {
    execute_hit1: spec('luna_exec_stab_c', 1, -9.8, 0.05, -17.5),
    execute_hit2: spec('luna_exec_push_c', 1, -10.7, 0.04, -17.1),
    execute_hit3: spec('luna_exec_pull_c', 1, -6.4, 0.08, -17.9),
  },
  // synth = 1版目 (数式の部品だけ・scripts/render_lunaire_finisher_sound.py)
  synth: {
    execute_hit1: spec('luna_exec_stab', 1, -5.0, 0.05, -25.3),
    execute_hit2: spec('luna_exec_push', 1, -11.9, 0.05, -19.4),
    execute_hit3: spec('luna_exec_pull', 1, -7.6, 0.08, -17.7),
  },
}
export const LUNA_FIN_SFX_SETS: Record<LunaFinSfxSet, FinSet> = {
  // 4版目: 名前の鐘なし。刺す = 致命でいちばん大きい一打 (二段で刺さり、止めの 0.48 秒に刃の鳴りが細く残る)／抜く = 擦れが上がって抜け、金の火花と刃の鳴り。
  v4g: {
    execute: spec('luna_fin_hit_v4g', 1, -6.6, 0.05, -17.2, -21.0),
    finisher_pull: spec('luna_fin_pull_v4g', 1, -8.5, 0.06, -17.2, -22.5),
  },
  v4h: {
    execute: spec('luna_fin_hit_v4h', 1, -6.8, 0.05, -17.5, -20.9),
    finisher_pull: spec('luna_fin_pull_v4h', 1, -8.2, 0.06, -17.5, -22.4),
  },
  v4i: {
    execute: spec('luna_fin_hit_v4i', 1, -6.8, 0.05, -17.3, -21.0),
    finisher_pull: spec('luna_fin_pull_v4i', 1, -8.2, 0.06, -17.4, -22.2),
  },
  // 3版目: 鳴り (鐘・銀・ガラス) を刺す・抜くから外し、深い肉と体の受けで作り直した。名前の鐘は低く暗い鉄の鐘 (2版目より約 1 オクターブ下)。
  v3d: {
    execute: spec('luna_fin_hit_v3d', 1, -6.8, 0.04, -14.0, -21.0),
    finisher_pull: spec('luna_fin_pull_v3d', 1, -7.9, 0.05, -14.0, -22.3),
    finisher_name: spec('luna_fin_name_v3', 1, -17.6, 0.08, -14.0, -32.1),
  },
  v3e: {
    execute: spec('luna_fin_hit_v3e', 1, -6.6, 0.04, -14.0, -21.0),
    finisher_pull: spec('luna_fin_pull_v3e', 1, -8.0, 0.05, -14.0, -22.3),
    finisher_name: spec('luna_fin_name_v3', 1, -17.6, 0.08, -14.0, -33.0),
  },
  v3f: {
    execute: spec('luna_fin_hit_v3f', 1, -7.0, 0.04, -14.0, -21.0),
    finisher_pull: spec('luna_fin_pull_v3f', 1, -7.8, 0.05, -14.0, -22.4),
    finisher_name: spec('luna_fin_name_v3', 1, -17.6, 0.08, -14.0, -32.7),
  },
  v2: {
    execute: spec('luna_fin_hit_v2', 1, -6.8, 0.06, -17.4),
    finisher_pull: spec('luna_fin_pull_v2', 1, -7.9, 0.08, -17.6),
    finisher_name: spec('luna_fin_name_v2', 1, -16.5, 0.1, -18.8),
  },
  v1: {
    execute: spec('luna_fin_hit', 1, -6.5, 0.06, -17.3),
    finisher_pull: spec('luna_fin_pull', 1, -7.2, 0.08, -18.1),
    finisher_name: spec('luna_fin_name', 1, -16.9, 0.1, -17.4),
  },
}
export const LUNA_EXEC_SFX_DEFAULT: LunaExecSfxSet = 'g'
export const LUNA_FIN_SFX_DEFAULT: LunaFinSfxSet = 'v4g'
/** &lunaFinBell=on で鳴らす名前の鐘 (組が鐘を持たない時 = 3版目の低く暗い鉄の鐘)。 */
export const LUNA_FIN_BELL_FALLBACK: LunaSfxSpec = LUNA_FIN_SFX_SETS.v3d.finisher_name!
/** いま鳴らす表 (audio.ts が読む)。中身は setLunaSfxChoice が入れ替える。 */
export const LUNA_SFX: Partial<Record<SfxId, LunaSfxSpec>> = {}
/** 開発版のスイッチ (game.ts の DEV の箱だけが呼ぶ)。知らない値・指定なし = 既定の組。
 *  bell = 'on' の時だけ名前の鐘を鳴らす (組の鐘・無ければ LUNA_FIN_BELL_FALLBACK)。指定なし = 鳴らさない (ユーザー「鐘は要らない」10-13)。 */
export function setLunaSfxChoice(exec: string | null | undefined, fin: string | null | undefined, bell?: string | null): void {
  const e = (exec && exec in LUNA_EXEC_SFX_SETS ? exec : LUNA_EXEC_SFX_DEFAULT) as LunaExecSfxSet
  const f = (fin && fin in LUNA_FIN_SFX_SETS ? fin : LUNA_FIN_SFX_DEFAULT) as LunaFinSfxSet
  const set = LUNA_FIN_SFX_SETS[f]
  Object.assign(LUNA_SFX, LUNA_EXEC_SFX_SETS[e], { execute: set.execute, finisher_pull: set.finisher_pull })
  if (bell === 'on') LUNA_SFX.finisher_name = set.finisher_name ?? LUNA_FIN_BELL_FALLBACK
  else delete LUNA_SFX.finisher_name   // 表に無い = audio.ts は何も鳴らさない (前の版の音へも戻さない)
}
setLunaSfxChoice(null, null)
/** 先読みする全部の音 (組を URL で替えても鳴るように、どの組も読む)。 */
export function lunaSfxAllSamples(): [string, string][] {
  const all = [...Object.values(LUNA_EXEC_SFX_SETS), ...Object.values(LUNA_FIN_SFX_SETS)].flatMap((s) => Object.values(s) as LunaSfxSpec[])
  const seen = new Set<string>()
  return all.filter((v) => !seen.has(v.sample) && !!seen.add(v.sample)).map((v) => [v.sample, v.url] as [string, string])
}
export const LUNA_SFX_OUTPUT_OFFSET_DB = 3.3
/** ゲームの出力の見積もり (400ms の最大ラウドネス)。測った値 (outM400) があればそれ、無ければ fileM400 + gainDb + 3.3。 */
export function lunaSfxOutputM400(s: LunaSfxSpec): number {
  return s.outM400 ?? s.fileM400 + s.gainDb + LUNA_SFX_OUTPUT_OFFSET_DB
}
